import styled, { css } from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const StyledProductBoxImage = styled.figure<{ isPlaceholder: boolean }>`
  margin: 0;
  background: ${({ isPlaceholder, theme }) => (isPlaceholder ? theme.tertiaryColour : 'none')};
  min-height: ${({ isPlaceholder }) => (isPlaceholder ? '350px' : '0')};

  ${({ isPlaceholder }) => media.xl`
    min-height: ${isPlaceholder ? '587px' : '0'};
  `}

  img {
    display: block;
    width: 100%;
    max-width: 100%;
    margin: 0;
  }
`;

export const ImageButton = styled.button<{ isSelected?: boolean }>`
  outline: none;
  border: 0;
  padding: 0 10px 0 0;
  background: none;
  cursor: pointer;

  ${({ isSelected }) =>
    isSelected &&
    css`
      opacity: 0.6;
    `}

  ${media.md`
    padding: 0 14px 0 0;
  `}

  img {
    display: block;
    height: 120px;
    width: 120px;

    ${media.md`
      height: 140px;
      width: 140px;
    `}
  }
`;

export const ImageColumn = styled.div`
  width: 100%;
  flex-shrink: 0;
`;

export const ImagesList = styled.ul`
  padding: 10px 20px 20px 10px;
  list-style: none;
  display: flex;
  justify-content: flex-start;
  max-width: 100%;
  overflow-x: auto;

  ${media.md`
    padding: 14px 0;
  `}
`;

export const SliderWrapper = styled.section`
  width: 100%;
  padding: 10px 20px;

  ${media.md`
    padding: 14px 0;
  `}

  .slick-initialized .slick-track {
    display: flex;

    .slick-slide {
      display: flex;
      height: inherit !important;
      align-items: stretch;
      justify-content: stretch;
    }
  }
`;
